module.exports = __webpack_public_path__ + "static/media/charts-dashboards.5e0ae28f.svg";